export function initAside(){

	const asides = document.querySelectorAll('aside');

	if (!asides.length) return;

	asides.forEach(aside => {

		const items = aside.querySelectorAll('li');

		items.forEach(li => {

			const link = li.querySelector(':scope > a');
			if (!link) return;

			// --------------------------------
			// External links (all asides)
			// --------------------------------

			const isExternal = link.getAttribute('target') === '_blank' && !link.hasAttribute('download');

			if (isExternal && !link.querySelector('.icon--external')) {

				const icon = document.createElement('span');
				icon.className = 'icon icon--target icon--external icon--sm';

				link.append(icon);

			}

			// --------------------------------
			// Collapse (only for nested lists)
			// --------------------------------

			if (!aside.classList.contains('aside--collapsable')) return;

			const subMenu = li.querySelector(':scope > ul');
			if (!subMenu) return;

			// evitar aplicar al primer nivel salvo opt-in
			const parentUL = li.parentElement;
			const isRootLevel = parentUL === aside.querySelector('ul');
			const allowRoot = aside.classList.contains('aside--collapsable-root');

			if (isRootLevel && !allowRoot) return;

			if (li.querySelector(':scope > .aside__collapse')) return;

			const toggle = document.createElement('div');
			toggle.className = 'aside__collapse';

			li.insertBefore(toggle, link);

			toggle.addEventListener('click', e => {

				e.preventDefault();
				e.stopPropagation();

				const isOpen = li.classList.contains('_open');

				const siblings = li.parentElement.querySelectorAll(':scope > li');

				siblings.forEach(sibling => {

					if (sibling !== li) {

						sibling.classList.remove('_open');

						sibling.querySelectorAll('li._open').forEach(child => {
							child.classList.remove('_open');
						});

					}

				});

				if (isOpen) {
					li.classList.remove('_open');
				}else{
					li.classList.add('_open');
				}

			});

		});

		// --------------------------------
		// Open active branch
		// --------------------------------

		if (aside.classList.contains('aside--collapsable')) {

			const activeItems = aside.querySelectorAll('.current-menu-item, .current_page_item');

			activeItems.forEach(item => {

				let parent = item.closest('li');

				while (parent) {

					parent.classList.add('_open');
					parent = parent.parentElement.closest('li');

				}

			});

		}

	});

}